
interface Department {
  name: string;
  phone: string;
}

interface CallUsForm {
  onClose: () => void;
}

const departments: Department[] = [
  { name: "Sales", phone: "0800 123 4567" },
  { name: "Support", phone: "0800 765 4321" },
  { name: "Billing", phone: "0800 111 2222" },
  { name: "Technical", phone: "0800 333 4444" },
];

const CallUs = ({ onClose }: CallUsForm) => {
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
        <button
          onClick={onClose}
          className="absolute top-0 right-0 mt-2 mr-2 bg-transparent hover:bg-gray-200 text-gray-800 font-semibold py-1 px-2 rounded"
        >
          X
        </button>
        <div className="border-b border-gray-300 pb-4 mb-4">
        <h2 className="text-2xl font-bold text-center mb-4">Call Us</h2>
        </div>
        <ul className="space-y-4">
          {departments.map((dept, index) => (
            <li key={index} className="flex justify-between items-center border-b pb-2">
              <span className="font-medium">{dept.name}</span>
              <a href={`tel:${dept.phone}`} className="text-blue-600 hover:underline">
                {dept.phone}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CallUs;
export {};